import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IOrganizationTask, IOrganizationTaskRequest } from "@ontime/types";

const API_URL = (organizationId: string) => `${ApiURL()}/organizations/${organizationId}/organizationTask`;

class OrganizationTaskService {

    async GetList(organizationId: string, showDeleted: boolean = false): Promise<IOrganizationTask[]> {
        const response = await axios.get<IOrganizationTask[]>(API_URL(organizationId), {
            headers: AuthHeader(),
            params: { showDeleted }
        });
        return response.data;
    }

    async Get(organizationId: string, organizationTaskId: string): Promise<IOrganizationTask> {
        const response = await axios.get<IOrganizationTask>(`${API_URL(organizationId)}/${organizationTaskId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, input: IOrganizationTaskRequest): Promise<IOrganizationTask> {
        const response = await axios.post<IOrganizationTask>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, input: IOrganizationTaskRequest): Promise<IOrganizationTask> {
        const response = await axios.put<IOrganizationTask>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, organizationTaskId: string, currentIsDeleted: boolean): Promise<{ organizationTaskId: string }> {
        const response = await axios.delete<{ organizationTaskId: string }>(`${API_URL(organizationId)}/${organizationTaskId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new OrganizationTaskService();